import React from 'react';
import { useSnackbar } from 'notistack';

import { useDispatch, useSelector } from 'react-redux';
import * as fileApi from '../../../lib/api/file';
import * as employeeApi from '../../../lib/api/employee';
import { setEmployee } from '../../../modules/empModule/employee';
import EmpFileUpload from '../../../components/common/fileupload/EmpFileUpload';

const EmpFileUploadContainer = ({fileTyp, fileAttrVal1}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { employee } = useSelector(({ empModule }) => ({
    employee: empModule.employee.employee,
  }));

  const uploadProfileImage = async (file) => {
    let formData = new FormData();
    formData.append('fileDt', file);
    formData.append('fileTyp', fileTyp);
    formData.append('fileAttrVal1', fileAttrVal1);

    try {
      const res = await fileApi.addFiles(formData);


      const dataToSubmit = {
        usrUuid: fileAttrVal1,
        profileImg: res.data.info.fileUrl,
      };
      const usrRes = await employeeApi.editEmployee(dataToSubmit);
      console.log(usrRes);
      dispatch(setEmployee(usrRes.data.info));
      enqueueSnackbar('사용자 프로필 이미지 저장 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  // 프로필 이미지 삭제(관리자가 사원 편집) - usrUuid가 본인이 아니면 서버에서 관리자만 허용.
  // bito 스토리지 테스트(2026-10-30).
  const removeProfileImage = async () => {
    try {
      const res = await fileApi.removeProfileByUuid(fileAttrVal1);
      dispatch(setEmployee(res.data.info));
      enqueueSnackbar('사용자 프로필 이미지 삭제 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <EmpFileUpload
      uploadProfileImage={uploadProfileImage}
      removeProfileImage={removeProfileImage}
      hasImage={Boolean(employee?.profileImg)}
    />
  );
};

export default EmpFileUploadContainer;
